import styled from 'styled-components';

export const FooterWrapper = styled.div`
  width: 100vw;
  height: auto;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  background-color: ${props => props.theme.color.dark};
  padding: 10px 0;
`

export const FooterLogo = styled.img`
  width: 200px;
  height: auto;
  margin: 10px 0;
`

export const FooterRights = styled.div`
  font-family: ${props => props.theme.font.primary};
  font-size: ${props => props.theme.fontSize.xxs};
  color: ${props => props.theme.color.bright};
`